import { APP_PERMISSIONS } from '@exam-center/permission';
import { Box, Button, FileDownloadOutlinedIcon, Text, Tooltip } from '@shared/components';
import { useDisclosure } from '@shared/hooks';
import { WithPermission } from '@shared/permissions';

import { DownloadExamConfirmationModal } from '../download-exam-confirmation-modal';

type DISABLED_REASON = 'NO_ASSIGNED_EXAM_PAPER' | 'EXAM_ENDED';

const DISABLED_REASON_LABEL: Record<DISABLED_REASON, string> = {
  NO_ASSIGNED_EXAM_PAPER: 'ยังไม่มีการมอบหมายชุดข้อสอบให้กับรอบสอบนี้',
  EXAM_ENDED: 'ไม่สามารถดาวน์โหลดได้\nเนื่องจากการสอบเสร็จสิ้นแล้ว',
};

interface DownloadExamButtonProps {
  examEventId: string;
  disabled?: boolean;
  disabledReason?: DISABLED_REASON;
}

export default function DownloadExamButton(props: Readonly<DownloadExamButtonProps>) {
  const { examEventId, disabled, disabledReason } = props;

  const [
    isOpenConfirmDownloadExamModal,
    { open: openConfirmDownloadExamModal, close: closeConfirmDownloadExamModal },
  ] = useDisclosure(false);

  const tooltipTitle = disabledReason ? DISABLED_REASON_LABEL[disabledReason] : '';

  return (
    <WithPermission requiredPermission={APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.EXAMINEES.UPDATE}>
      <Tooltip
        slotProps={{ popper: {} }}
        title={<Text variant='caption'>{tooltipTitle}</Text>}
        arrow
        placement='top'
        disableHoverListener={!disabled}
      >
        <Box component='span' sx={{ maxWidth: 'fit-content' }}>
          <Button
            variant='contained'
            color='primary'
            onClick={openConfirmDownloadExamModal}
            startIcon={<FileDownloadOutlinedIcon />}
            disabled={disabled}
          >
            ดาวน์โหลดชุดข้อสอบ
          </Button>
        </Box>
      </Tooltip>
      <DownloadExamConfirmationModal
        examEventId={examEventId}
        open={isOpenConfirmDownloadExamModal}
        onClose={closeConfirmDownloadExamModal}
      />
    </WithPermission>
  );
}
